// extracted by mini-css-extract-plugin
module.exports = {"main":"FichaCliente_main__2ENBC"};